var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckOkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5399 6.82014L11.5399 6.82019L11.5458 6.8141C11.9233 6.42365 11.9317 5.7982 11.5399 5.40637C11.1513 5.01777 10.5147 5.01777 10.1261 5.40637L7.05301 8.47948L5.87323 7.2997C5.48463 6.9111 4.84805 6.9111 4.45945 7.2997C4.07086 7.68829 4.07086 8.32488 4.45945 8.71347L6.34612 10.6001L6.69967 10.2466L6.34612 10.6001C6.53215 10.7862 6.78556 10.8933 7.05301 10.8933C7.32046 10.8933 7.57386 10.7862 7.75989 10.6001L11.5399 6.82014ZM1.83301 7.99992C1.83301 4.60273 4.60248 1.83325 7.99967 1.83325C11.3969 1.83325 14.1663 4.60273 14.1663 7.99992C14.1663 11.3971 11.3969 14.1666 7.99967 14.1666C4.60248 14.1666 1.83301 11.3971 1.83301 7.99992Z",
    fill: "#009B4B",
    stroke: "#009B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOkIcon);
export default __webpack_public_path__ + "static/media/check_ok_icon.00d702ff418524d1e5a9c68ebb7ea77e.svg";
export { ForwardRef as ReactComponent };